module.exports = __webpack_public_path__ + "media/images/logo-green-fd2a0380.png";